import Home from '@/views/Home.vue';
import { RouteConfig } from 'vue-router';

const commonRoute = [
	{
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: '/maintenance',
		name: 'maintenance',
		component: () => import(
			/* webpackChunkName: "maintenance" */
			'../../views/Maintenance.vue'
		)
	},
	{
		path: '*', // Everything that doesn't match a route
		name: 'notFound',
		component: () => import(
			/* webpackChunkName: "not-found" */
			'../../views/exception/NotFound.vue'
		)
	}
] as RouteConfig[];

export default commonRoute;
